module.exports = __webpack_public_path__ + "assets/img/miniQrcode.82c96677.jpg";